// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { shareListModalStyles } from "@vanmeter/Overrides/Components/ShareListModal";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

shareListModalStyles.recipientEmailTooltip =
    shareListModalStyles.shareListTooltip =
    shareListModalStyles.shareByEmailTooltip =
    shareListModalStyles.shareByBillingTooltip =
        {
            triggerWrapper: {
                css: css`
                    margin-left: 6px;
                    position: relative;
                    line-height: 1;
                `,
            },
        };

shareListModalStyles.modal = { mergeCss: true, sizeVariant: "medium" };

shareListModalStyles.buttonsContainer = {
    gap: 10,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
        }
    `,
};

shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        align-items: baseline;
        margin-top: 6px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup;

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 12 };

shareListModalStyles.buttonsContainer = { gap: 0 };

shareListModalStyles.allowEditingGridItem = {
    width: 12,
    css: css`
        padding-bottom: 12px;
    `,
};

shareListModalStyles.cancelButtonGridItem = {
    width: 12,
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 12px;
        `,
    }),
};

shareListModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

shareListModalStyles.sendButton = {
    ...modalButtonsActionStyles.submitButton,
};
